import { Component } from "@angular/core";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { Iso3166_1, Language } from "../../../../_model/Language";
import { PHBGlobals } from "../../../../_config/config";
import { IsoCodeToCountryNamePipe } from "../../../pipes/isoCode-to-country-name.pipe";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";

@Component({
	selector: "language-modal",
	templateUrl: "./language-modal.component.html",
	styleUrls: ["./language-modal.component.scss"],
	standalone: true,
	imports: [CommonModule, MatDialogModule, MatButtonModule, IsoCodeToCountryNamePipe]
})
export class LanguageModalComponent {
	constructor(public dialogRef: MatDialogRef<LanguageModalComponent>) {
	}

	fallbackDisabled: boolean = false;

	get currentUser() {
		return PHBGlobals.user;
	}

	get currentLanguage(): Language {
		return PHBGlobals.language;
	}

	get currentCountry(): Iso3166_1 | "__" {
		if (PHBGlobals.currentCountry) {
			return PHBGlobals.currentCountry;
		}
		const currentLang = this.currentLanguage;
		if (currentLang && currentLang.countries && currentLang.countries.length > 0) {
			return currentLang.countries[0];
		}
		return "__";
	}

	get languages(): Language[] {
		return PHBGlobals.plainLanguages.filter(it => {
			return PHBGlobals.user.languages.includes(it.isocode);
		});
	}

	get isGerman(): boolean {
		const browserLang = navigator.language || (navigator as any).userLanguage;
		return browserLang && browserLang.toLowerCase().startsWith("de");
	}

	get dialogTitle(): string {
		return this.isGerman ? "Sprache wählen" : "Choose language";
	}

	get dialogDescription(): string {
		return this.isGerman
			? "Bitte wählen Sie Ihre bevorzugte Sprache für das Planerhandbuch aus. Die Dokumente werden Ihnen anschließend passend zu Ihrer Sprach- und Länderauswahl angezeigt."
			: "Please select your preferred language for the \"Planerhandbuch\". The documents will then be displayed according to your language and region selection.";
	}

	get cancelButtonText(): string {
		return this.isGerman ? "Abbrechen" : "Cancel";
	}

	get showAllTranslations(): boolean {
		return PHBGlobals.user && PHBGlobals.user.loggedIn && PHBGlobals.user.data.settings.showTranslations;
	}

	getFlagIcon(language: Language, country: Iso3166_1 | "__"): string {
		let flagName = "__";
		if (country && country !== "__") {
			flagName = country.toUpperCase();
		}
		return `assets/flags/${flagName}@2x.png`;
	}

	selectLanguage(language: Language, country: Iso3166_1 | "__") {
		PHBGlobals.user.data.settings.showTranslations = false;
		this.dialogRef.close({language, country});
	}

	// Falls das Bild fehlschlägt, auf __@2x.png zurückfallen
	onImageError(event: any) {
		event.target.src = "assets/flags/__@2x.png";
	}

	toggleLanguageFallback() {
		PHBGlobals.user.data.settings.showTranslations = !PHBGlobals.user.data.settings.showTranslations;
		this.dialogRef.close({language: this.currentLanguage, country: this.currentCountry});
	}
}
